// extracted by mini-css-extract-plugin
module.exports = {"description":"description--T-fST"};